/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Photos_GoneInputs */

const en_us2_body_assessment_photos_gone = /** @type {(inputs: Body_Assessment_Photos_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The photos from this assessment have been deleted. The numbers are still here.`)
};

const pt_br2_body_assessment_photos_gone = /** @type {(inputs: Body_Assessment_Photos_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As fotos desta avaliação foram apagadas. Os números continuam aqui.`)
};

const es_419_body_assessment_photos_gone = /** @type {(inputs: Body_Assessment_Photos_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las fotos de esta evaluación se borraron. Los números siguen aquí.`)
};

const pt_pt2_body_assessment_photos_gone = /** @type {(inputs: Body_Assessment_Photos_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As fotos desta avaliação foram apagadas. Os números continuam aqui.`)
};

const fr_fr2_body_assessment_photos_gone = /** @type {(inputs: Body_Assessment_Photos_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les photos de cette évaluation ont été supprimées. Les chiffres sont toujours là.`)
};

const de_de2_body_assessment_photos_gone = /** @type {(inputs: Body_Assessment_Photos_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Fotos dieser Messung wurden gelöscht. Die Zahlen sind noch da.`)
};

const it_it2_body_assessment_photos_gone = /** @type {(inputs: Body_Assessment_Photos_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le foto di questa valutazione sono state eliminate. I numeri sono ancora qui.`)
};

/**
* | output |
* | --- |
* | "The photos from this assessment have been deleted. The numbers are still here." |
*
* @param {Body_Assessment_Photos_GoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_photos_gone = /** @type {((inputs?: Body_Assessment_Photos_GoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Photos_GoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_photos_gone(inputs)
	if (locale === "es-419") return es_419_body_assessment_photos_gone(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_photos_gone(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_photos_gone(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_photos_gone(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_photos_gone(inputs)
	return en_us2_body_assessment_photos_gone(inputs)
});
export { body_assessment_photos_gone as "body-assessment.photos_gone" }